import { useState, useCallback } from 'react'
import Box from '@mui/material/Box'
import ShareCodeInput from './ShareCodeInput'
import UsernameInput from './UsernameInput'
import api from 'services/api'
import LoadingButton from '@mui/lab/LoadingButton'
import useToast from 'hooks/useToast'
import Heading from './Heading'
import { useAuth } from 'store/selectors'

const CopyReclip = () => {
  const { user } = useAuth()
  const toast = useToast()
  const [shareLink, setShareLink] = useState('')
  const [toUsername, setToUsername] = useState(user.username)
  const [isLoading, setIsLoading] = useState(false)

  const copyReclip = useCallback(async () => {
    if (!shareLink || !toUsername) return

    const shareCode = shareLink.split('/').slice(-1)[0]
    try {
      setIsLoading(true)
      await api.reclips.copyReclipByShareCode({
        shareCode,
        toUsername: toUsername.replace(/^@/, ''),
      })
      toast({ message: 'reclip copied to ' + toUsername })
      setShareLink('')
      setToUsername('')
    } catch (e) {
      toast({ message: e.message, severity: 'error' })
    } finally {
      setIsLoading(false)
    }
  }, [shareLink, toUsername, toast])

  return (
    <Box>
      <Heading text="1. Enter share link" />
      <ShareCodeInput shareLink={shareLink} onChange={setShareLink} />
      <Heading text="2. Choose the recipient username (defaults to you)" />
      <UsernameInput toUsername={toUsername} onChange={setToUsername} />
      <Heading text="3. Copy the Clip" />
      <LoadingButton
        variant="contained"
        disabled={!shareLink || !toUsername}
        onClick={copyReclip}
        loading={isLoading}
      >
        Copy Clip
      </LoadingButton>
    </Box>
  )
}

export default CopyReclip
